import getFormData from '../../api/Form/getFormData.api';
import {
	GET_FORM_ITEM_FAIL,
	GET_FORM_ITEM_SUCCESS,
	INIT_FORM_ITEMS,
} from './types';

export const getFormItems = (component, formId) => {
	return async (dispatch) => {
		try {
			getFormData(component, formId, (returned) => {
				dispatch(getFormItemsSuccess(returned));
			});
		} catch (error) {
			dispatch(getFormItemsFail(error));
		}
	};
};
export const initializeFormItems = () => {
	return async (dispatch) => {
		alert('1111111');
		dispatch(initializeFormSuccess());
	};
};
const getFormItemsSuccess = (payload) => ({
	type: GET_FORM_ITEM_SUCCESS,
	payload,
});

const getFormItemsFail = (payload) => ({
	type: GET_FORM_ITEM_FAIL,
	payload,
});

const initializeFormSuccess = () => ({
	type: INIT_FORM_ITEMS,
});
